import React, { useState } from "react";
import IssueUserIcon from "../../../Assets/Logos/issues/IssueUserIcon.png";
import { AiFillCloseCircle } from "react-icons/ai";
import axios from "axios";
import toast from "react-hot-toast";

const ReplyHereModal = ({ issue, isOpen, closeModal }) => {
  const [replyDescription, setReplyDescription] = useState("");
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  console.log("Issue: ", issue);

  //Fetching the userdata from the local storage
  const userData = JSON.parse(localStorage.getItem("yostelPG-userData"));

  //Function to add reply to an issue
  const addReply = () => {
    setLoading(true);
    const data = {
      replyDescription: replyDescription,
      userId: userData?._id,
    };
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/issues/replyToIssue/${issue?._id}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of addReply: ", response.data);
        toast.success(response.data.message);
        closeModal();
        setLoading(false);
      })
      .catch((error) => {
        console.log("Error in replying to an issue: ", error);
        toast.success("Error in replyting to an issue");
        setLoading(false);
      });
  };

  return (
    <div className="fixed inset-0 bg-black/50 p-1  backdrop-blur-sm flex justify-center items-center z-50">
      <div className="bg-white w-full max-w-lg relative rounded-lg shadow-lg p-6">
        <div className="flex justify-between items-center mb-4">
          <div className="flex gap-2">
            <img
              src={issue?.issueByUserId?.profilePic}
              alt="userIcon"
              className="w-12 h-12 object-cover"
            />
            <div className="flex  flex-col">
              <h2 className="text-gray-800 text-lg font-semibold">
                {issue?.issueByUserId?.name}
              </h2>
              <span className="ml-2 text-sm text-gray-500 capitalize  ">
                {" "}
                {issue?.issueByUserId?.userType}
              </span>
            </div>
          </div>

          <AiFillCloseCircle
            onClick={closeModal}
            className="cursor-pointer text-primaryColor absolute top-4 right-4"
            size={30}
          />
        </div>
        <p className="text-gray-700 mb-4">{issue?.issueDescription}</p>
        <textarea
          className="w-full h-24 border border-gray-300 rounded-lg p-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent"
          placeholder="Write your reply here"
          onInput={(e) => setReplyDescription(e.target.value)}
        ></textarea>
        <button
          onClick={addReply}
          className="mt-4 bg-primaryColor text-white px-4 py-2 rounded-lg w-full hover:bg-primaryBtnHoverColor transition-colors"
        >
          Submit
        </button>
      </div>

      {loading && (
        <div className="fixed inset-0 h-screen w-screen flex items-center justify-center bg-black bg-opacity-50">
          <span class="loader"></span>
        </div>
      )}
    </div>
  );
};

export default ReplyHereModal;
